export enum ScenarioType {
  Off = 0x00,
  On = 0x01,
  RightToLeft = 0x02,
  LeftToRight = 0x03,
  InsideToOutside = 0x04,
  OutsideToInside = 0x05,
}
